import React from 'react'

export function IconFiles() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        fill="#FAFAFA"
        fillRule="evenodd"
        d="M5 18.25a.75.75 0 01.75.75v2.25h12.5V19a.75.75 0 011.5 0v3a.75.75 0 01-.75.75H5a.75.75 0 01-.75-.75v-3a.75.75 0 01.75-.75zM4.25 2A.75.75 0 015 1.25h10a.75.75 0 01.586.281l4 5A.75.75 0 0119.75 7v3a.75.75 0 01-1.5 0V7.263L14.64 2.75H5.75V10a.75.75 0 01-1.5 0V2z"
        clipRule="evenodd"
      />
      <path
        fill="#FAFAFA"
        fillRule="evenodd"
        d="M14 1.25a.75.75 0 01.75.75v4.25H19a.75.75 0 010 1.5h-5a.75.75 0 01-.75-.75V2a.75.75 0 01.75-.75zM7.25 6A.75.75 0 018 5.25h2a.75.75 0 010 1.5H8A.75.75 0 017.25 6zM3 10.75a.25.25 0 00-.25.25v7c0 .138.112.25.25.25h18a.25.25 0 00.25-.25v-7a.25.25 0 00-.25-.25H3zM1.25 11c0-.966.784-1.75 1.75-1.75h18c.966 0 1.75.784 1.75 1.75v7A1.75 1.75 0 0121 19.75H3A1.75 1.75 0 011.25 18v-7z"
        clipRule="evenodd"
      />
      <path
        fill="#FAFAFA"
        fillRule="evenodd"
        d="M5 11.75a.75.75 0 01.75.75v4a.75.75 0 01-1.5 0v-4a.75.75 0 01.75-.75z"
        clipRule="evenodd"
      />
      <path
        fill="#FAFAFA"
        fillRule="evenodd"
        d="M4.25 12.5a.75.75 0 01.75-.75h1a2.75 2.75 0 010 5.5H5a.75.75 0 010-1.5h1a1.25 1.25 0 000-2.5H5a.75.75 0 01-.75-.75zM11.54 13.536c-.166.22-.29.558-.29.964 0 .406.124.744.29.964.164.22.335.286.46.286s.296-.066.46-.286c.166-.22.29-.558.29-.964 0-.406-.124-.744-.29-.964-.164-.22-.335-.286-.46-.286s-.296.066-.46.286zm-1.2-.9c.377-.504.957-.886 1.66-.886s1.283.382 1.66.886c.379.504.59 1.165.59 1.864 0 .699-.211 1.36-.59 1.864-.377.504-.957.886-1.66.886s-1.283-.382-1.66-.886c-.378-.504-.59-1.165-.59-1.864 0-.699.212-1.36.59-1.864zM15.25 14.5A2.75 2.75 0 0118 11.75h1a.75.75 0 010 1.5h-1a1.25 1.25 0 000 2.5h1a.75.75 0 010 1.5h-1a2.75 2.75 0 01-2.75-2.75z"
        clipRule="evenodd"
      />
    </svg>
  )
}
